export default "__VITE_ASSET__DLMFgYGG__"